module.exports = __webpack_public_path__ + "static/Leaves Fall 2-44bbed427178a7761b2dfb54d5ff1972.jpg";